import {
  Box,
  Tooltip,
  ButtonBase,
  IconButton,
  Popper,
  ClickAwayListener
} from "@material-ui/core";
import MsgIcon from "Assets/images/comment.svg";
import React, { useState } from "react";
import { get } from "lodash";
import useStyles from "./styles";
import { visionWordsAndCommentsMutation } from "../../../graphQL/mutation/visionBoardMutations";
import { useMutation } from "@apollo/client";
import LoadingWidget from "../../widgets/LoadingWidget";
import { useTranslation } from "react-i18next";
import { getUserId } from "../../../utils";
import Comments from "Modules/Vision/Banner/Comments"
import { visionNotificationState } from "../../../recoil/Vision/atom";
import { useRecoilState } from "recoil";

const VisionCommentPopover = ({
  visionDetail,
  visionId,
  setDisplayVision,
  setMyVision,
  listVision,
  updateNotification,
  notification,
  noDetails,
  isForCount
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  // const [comment, setComment] = useState("");
  const [comment, setComment] = useRecoilState(visionNotificationState)
  const [commentError, setCommentError] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const userId = getUserId();
  // const element = document.getElementById("commentWidth")

  // const commentWidth = element ? `${element.offsetWidth} px` : "35rem";
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setCommentError("");
    setComment("");
    setAnchorEl(null);
  };
  const [addComment] = useMutation(visionWordsAndCommentsMutation);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  // const elementChange = e => {
  //   const { value } = e.target;
  //   setCommentError("");
  //   setComment(value);
  // };
  const handleOnClick = () => {
    setAnchorEl(null)
  }
  // const containerRef = useRef();
  const giveComment = () => {
    if (comment && (comment || "").length < 5000 && comment && comment.replace(/\s/g, '').length) {
      setLoading(true);
      const variables = {
        input: {
          visionId,
          responseType: "Comment",
          createdByUserId: userId,
          comment,
        },
      };
      addComment({ variables }).then(res => {
        if (updateNotification) {
          updateNotification(notification);
        }
        if (setMyVision && setDisplayVision) {
          const newEncouragement = get(
            res,
            "data.visionWordsAndCommentsMutation",
            {}
          );
          const commentData = get(visionDetail, "comments.items", []) || [];
          const value = [...commentData, newEncouragement];
          const currentVision = {
            ...visionDetail,
            comments: { items: value },
          };
          setDisplayVision(currentVision);
          const visions = (listVision || []).map(data => {
            if (visionId === data.id) {
              return currentVision;
            }
            return data;
          });
          setMyVision(visions);
        }
        setLoading(false);
        handleClose();
      });
    } else {
      setLoading(false)
      setCommentError(!comment ? "Enter Comment" : "Enter valid comment");
    }
  };
  return (
    <ClickAwayListener onClickAway={handleOnClick}>
      <Box className={classes.visionCommentPopover} id="commentId">
        <Tooltip title={t("dashboard.comment")}>
          <ButtonBase data-testid="btn" disabled={noDetails} onClick={handleClick}>
            {isForCount ? get(visionDetail, "totalComments", 0) : <img src={MsgIcon} alt="icon" />}
          </ButtonBase>
        </Tooltip>
        {/* {get(visionDetail, "enableComments", false) ? ( */}
        <Popper
          id={id}
          open={open}
          anchorEl={anchorEl}
          className={classes.visionCommentPopper}
        // style={{ width: commentWidth }}
        >
          <Box>
            <Comments visionId={visionId} visionCreator={get(visionDetail, "createdByUserId", "")} />
            <Box className={classes.sendBtn}>
              <IconButton
                data-testid="giveComment"
                aria-label="delete"
                color="primary"
                onClick={giveComment}
              >
                {loading ? (
                  <LoadingWidget color="grey" />
                ) : (
                  ""
                )}
              </IconButton>
            </Box>
          </Box>
        </Popper>
        {/* ) : null} */}
      </Box>
    </ClickAwayListener>
  );
};

export default VisionCommentPopover;
